import React from "react";
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useTranslation } from 'react-i18next';
import * as rdd from 'react-device-detect';
import isWebview from 'is-ua-webview';
import { Paper, Grid } from "@material-ui/core";
import { useTheme, makeStyles } from '@material-ui/core/styles';
import MenuIcon from './components/MenuIcon';
import { Link } from 'react-tiger-transition';
import NavigationHelper from '../utils/NavigationHelper';
import IconButton from '@material-ui/core/IconButton';

const nh = NavigationHelper;

const useStyles = makeStyles({
    fixTop: {
        position: 'fixed',
        left: '9px',
        right: '9px',
        zIndex: 1000,
        height: '72px',
    },
    fixBottom: {
        position: 'fixed',
        left: '9px',
        right: '9px',
        zIndex: 1000,
        height: '72px',
    },
    shadowBox: {
        background: '#FFFFFF 0% 0% no-repeat padding-box',
        boxShadow: '0px 0px 10px #00000027',
        borderRadius: '14px',
        opacity: 1,
        paddingBottom: '6px',
        //padding: '12px 6px 6px 6px',
        fontSize: '12px',
        width: '100%',
    }
});

const MenuBar = ( ) => {
    const { t } = useTranslation();
    const gstate = useGlobalState(globalState);
    const iconSize = 32;
    const theme = useTheme();
    const wDim = useWindowDimensions();
    const classes = useStyles();

    const getPageName = function (index, packageName) {
        return t(nh.getPageName(index, packageName));
    }
    const currentIndex = gstate.currentIndex.get();
    const transition = "fade";
    var bottomTop = window.innerHeight - 76;
    if (rdd.isIOS && isWebview) {
        bottomTop = bottomTop - 10;
    }
    return (
        <React.Fragment>
            <div className={wDim.desktop ? classes.fixTop : classes.fixBottom} style={{ top: wDim.desktop ? '9px' : bottomTop.toString() + 'px' }}>
                <Grid container direction="row" justify="space-around" alignItems="center">
                    <Paper className={classes.shadowBox} style={{ fontFamily: theme.typography.fontFamily2, maxWidth: wDim.desktop ? '743px' : 'unset' }}>
                        <div style={{ maxWidth: !wDim.desktop ? '600px' : 'unset', overflowX: 'auto', scrollbarWidth: rdd.isFirefox ? 'thin' : null, marginLeft: 'auto', marginRight: 'auto' }}>
                            <Grid container direction="row" justify="space-around" alignItems="center" style={{ minWidth: '300px' }}>
                                <Grid item component={Link} replace style={{ textAlign: 'center', textDecoration: 'none', cursor: 'pointer', marginLeft: wDim.desktop ? '-25px' : 'unset' }} className="noselect" to="/home" transition={transition}>
                                    <IconButton>
                                        <MenuIcon name={currentIndex === 0 ? 'menu-0-fill' : 'menu-0'} size={iconSize} />
                                    </IconButton>
                                    <div style={{ color: currentIndex === 0 ? theme.palette.primary.main : theme.palette.text.primary, marginTop: '-10px' }}>{getPageName(0)}</div>
                                </Grid>
                                <Grid item component={Link} replace style={{ textAlign: 'center', textDecoration: 'none', cursor: 'pointer' }} className="noselect" to="/invoice-list" transition={transition}>
                                    <IconButton>
                                        <MenuIcon name={currentIndex === 1 ? 'menu-1-fill' : 'menu-1'} size={iconSize} />
                                    </IconButton>
                                    <div style={{ color: currentIndex === 1 ? theme.palette.primary.main : theme.palette.text.primary, marginTop: '-10px' }}>{getPageName(1, gstate.PackageType.get())}</div>
                                </Grid>
                                <Grid item component={Link} replace style={{ textAlign: 'center', textDecoration: 'none', cursor: 'pointer' }} className="noselect" to="/subscriptions" transition={transition}>
                                    <IconButton>
                                        <MenuIcon name={currentIndex === 2 ? 'menu-2-fill' : 'menu-2'} size={iconSize} />
                                    </IconButton>
                                    <div style={{ color: currentIndex === 2 ? theme.palette.primary.main : theme.palette.text.primary, marginTop: '-10px' }}>{getPageName(2)}</div>
                                </Grid>
                                <Grid item component={Link} replace style={{ textAlign: 'center', textDecoration: 'none', cursor: 'pointer' }} className="noselect" to="/shopping" transition={transition}>
                                    <IconButton>
                                        <MenuIcon name={currentIndex === 3 ? 'menu-3-fill' : 'menu-3'} size={iconSize} />
                                    </IconButton>
                                    <div style={{ color: currentIndex === 3 ? theme.palette.primary.main : theme.palette.text.primary, marginTop: '-10px' }}>{getPageName(3)}</div>
                                </Grid>
                                <Grid item component={Link} replace style={{ textAlign: 'center', textDecoration: 'none', cursor: 'pointer', marginRight: wDim.desktop ? '-25px' : 'unset' }} className="noselect" to="/support" transition={transition}>
                                    <IconButton>
                                        <MenuIcon name={currentIndex === 4 ? 'menu-4-fill' : 'menu-4'} size={iconSize} />
                                    </IconButton>
                                    <div style={{ color: currentIndex === 4 ? theme.palette.primary.main : theme.palette.text.primary, marginTop: '-10px' }}>{getPageName(4)}</div>
                                </Grid>
                            </Grid>
                        </div>
                    </Paper>
                </Grid>
            </div>
        </React.Fragment>
    );
};

export default MenuBar;